<template>
  <div class="pageWrapper">
    <div
      v-if="currentStep !== 3 && !$vuetify.breakpoint.smAndDown"
      class="preSessionHeader text-center"
    >
      <div class="backContainer">
        <div
          @click="onStepperBack"
          class="backContainerInner"
         >
          <div class="backImageContainer text-center">
            <img
              src="@/assets/newPreSession/backIcon.png"
              alt=""
              class="backIcon"
              :style="{'transform' : !$vuetify.rtl ? 'rotate(180deg)' : '' }"
            />
          </div>
          <div class="backText body-medium-16-regular">{{ $t("back") }}</div>
        </div>
      </div>
      <pre-session-stepper :current-step="currentStep" />
      <div class="backContainer"></div>
    </div>

    <div v-if="currentStep !== 3 && $vuetify.breakpoint.smAndDown">
      <pre-session-stepper-mobile
        @go-back="onStepperBack"
        :currentStep="currentStep"
      />
    </div>

    <new-pressesion-step-one
      v-if="currentStep === 1 && !$vuetify.breakpoint.smAndDown"
      @change-step="currentStep = $event"
      @set-date="finalDate = $event"
    />

    <new-pressesion-step-one-mobile
      v-else-if="currentStep === 1 && $vuetify.breakpoint.smAndDown"
      @change-step="currentStep = $event"
      @set-date="finalDate = $event"
    />

    <new-pressesion-step-two
      v-else-if="currentStep === 2"
      @change-step="currentStep = $event"
      @counselor-data="counselorData = $event"
      :finalDate="finalDate"
    />

    <new-pressesion-step-three
      v-else-if="currentStep === 3"
      @change-step="currentStep = $event"
      :finalDate="finalDate"
      :counselorData="counselorData"
    />

    <a
      href="https://wa.me/00989302672054"
      target="_blank"
      :class="currentStep == 3 ? 'whatsapp-float-step-three' : 'whatsapp-float'"
    >
      <img
        src="@/assets/newPreSession/whatsapp.png"
        alt="WhatsApp"
        class="whatsapp-icon"
      />
    </a>
  </div>
</template>

<script>
import PreSessionStepper from "@/components/PreSession/preSessionStepper.vue";
import NewPressesionStepOne from "@/views/presession/newPressesionStepOne.vue";
import NewPressesionStepTwo from "@/views/presession/newPressesionStepTwo.vue";
import NewPressesionStepThree from "@/views/presession/newPressesionStepThree.vue";
import NewPressesionStepOneMobile from "@/views/presession/newPressesionStepOneMobile.vue";
import PreSessionStepperMobile from "@/components/PreSession/preSessionStepperMobile.vue";
import { EventBus } from "@/event-bus";

export default {
  components: {
    PreSessionStepperMobile,
    NewPressesionStepOneMobile,
    NewPressesionStepThree,
    NewPressesionStepTwo,
    NewPressesionStepOne,
    PreSessionStepper,
  },
  data() {
    return {
      currentStep: 1,
      finalDate: null,
      counselorData: null,
    };
  },
  mounted() {

    this.requesting("user", "canAttendPreSession").then((resp) => {
      if (!resp.data.can_attend) {
        EventBus.$emitEvent("notify", {
          title: "شما جلسه پیش مشاوره خود را ست کرده اید",
          color: "red",
        });
        this.$router.push({ name: "dashboard" });
      }
    });
  },
  watch: {
    currentStep() {
      this.$nextTick(() => {
        window.scrollTo({
          top: 0,
          behavior: "smooth",
        });
      });
    },
  },
  methods: {
    onStepperBack() {
      if (this.currentStep !== 1) {
        this.currentStep--;
      } else {
        window.location = "https://simiaroom.com/pre-session";
      }
    },
  },
};
</script>

<style scoped>
@media (min-width: 200px) and (max-width: 600px) {
  .whatsapp-float {
    bottom: 120px !important;
  }
}

@media (min-width: 300px) and (max-width: 1000px) {
  .eachBoxStyle {
    width: 700px !important;
  }
}

.pageWrapper {
  background-color: #f6f9fc;
  /*//overflow: scroll;*/
}

.preSessionHeader {
  background-color: white;
  width: 100%;
  box-shadow: 0 4px 12px -4px #0000001f;
  height: 128px;
  align-items: center;
  justify-content: center;
  display: flex;
}

.backIcon {
  width: 8px;
  height: 14px;
  margin-left: 4px;
}

.backImageContainer {
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.backContainer {
  padding: 0 70px;
  display: flex;
  flex: 1;
  cursor: pointer;
}

.backContainerInner {
  display: flex;
  flex-direction: row;
}

.whatsapp-float {
  position: fixed;
  bottom: 40px;
  right: 20px;
  z-index: 1000;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: white;
  border-radius: 50%;
  padding: 12px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
  transition: transform 0.2s ease-in-out;
}

.whatsapp-float-step-three {
  position: fixed;
  bottom: 20px;
  right: 20px;
  z-index: 1000;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: white;
  border-radius: 50%;
  padding: 12px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
  transition: transform 0.2s ease-in-out;
}

.whatsapp-float:hover {
  transform: scale(1.1);
}

.whatsapp-icon {
  width: 32px;
  height: 32px;
}

@keyframes pulse {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.1);
  }
  100% {
    transform: scale(1);
  }
}

.whatsapp-float {
  animation: pulse 2s infinite ease-in-out;
}
.backText {
  text-align: center;
   margin-top: 2px;
}
</style>
